const perfilSistemaEnum = {
    // OFERTA: {
    //     enumName: 'OFERTA',
    //     name: 'Oferta'        
    // },        
    SHOPPING: {
        enumName: 'SHOPPING',
        name: 'Shopping'
    },
    get(value) {        
        if(value === null)
            return perfilSistemaEnum.SHOPPING;

        var array = Object.values(perfilSistemaEnum);
        var perfilSistemaEnumFound = {};

        array.forEach(element => {
            if(element.enumName === value) {
                perfilSistemaEnumFound = element;      
                return ;          
            }            
        });   
        
        return perfilSistemaEnumFound;
    },
    list() {
        var array = Object.values(perfilSistemaEnum);
        var perfilSistemaList = [];

        // var perfilSistema = {};        

        // perfilSistema.valor = 0;
        // perfilSistema.texto = 'Selecione';

        // perfilSistemaList.push(perfilSistema);        

        array.forEach(element => {  
            if((element.name === 'get')||(element.name === 'list'))
                return ;    

            var perfilSistema = {};

            perfilSistema.valor = element.enumName;
            perfilSistema.texto = element.name;

            perfilSistemaList.push(perfilSistema);                
        });

        return perfilSistemaList;
    }
}

export default perfilSistemaEnum;